import { CartDescoutBy, Plan } from '../../shared/types/generated';

export const allItemsSameDiscount = (arr: number[]): boolean => {
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] !== arr[0]) {
      return false;
    }
  }
  return true;
};

export const getMaxNumber = (array: number[]): number => {
  let maxValue = array[0];

  for (let i = 1; i < array.length; i++) {
    if (array[i] > maxValue) {
      maxValue = array[i];
    }
  }

  return maxValue;
};

export const getValuesToupdateCardDiscount = (num: number): CartDescoutBy => {
  switch (num) {
    case 50:
      return CartDescoutBy.ProPlan;
    case 30:
      return CartDescoutBy.StandardPlan;
    case 20:
      return CartDescoutBy.StudentPlan;
    case 10:
      return CartDescoutBy.LoggedIn;
  }
  return CartDescoutBy.ProPlan;
};

export const getCustomTitle = (plan: Plan): string => {
  return plan.title_front?.toLowerCase().includes('estándar')
    ? 'Mensual'
    : plan.title_front?.toLowerCase()?.includes('profesional')
    ? 'Anual'
    : 'Estudiantil';
};

export const triggerEvent = (eventName: string): void => {
  if (typeof window != typeof undefined) {
    eval(`gtag('event','${eventName}');`);
    console.log(`gtag('event','${eventName}');`);
  }
};

export const triggerEventCustom = (event: string): void => {
  if (typeof window != typeof undefined) {
    eval(`dataLayer.push(${event});`);
    //console.log(`dataLayer.push(${event});`);
  }
};
